import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { loyaltyAccessControl } from '../access-control/loyaltyAccess.configuration'

const LoyaltyHubPageBuilderPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LoyaltyHubPageBuilderPage" */
      '../pages/loyalty-hub-page-builder/LoyaltyHubPageBuilderPage'
    )
)
// @hygen:inject page-import

export const loyaltyRouter = (
  <DomainRoute route="loyalty" accessControl={loyaltyAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="loyalty-hub-page-edit"
        component={LoyaltyHubPageBuilderPage as React.ComponentType<any>}
        accessControl={loyaltyAccessControl}
      />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
